import * as React from 'react';
import { useBreadcrumbs } from './BreadcrumbContext';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import BreadcrumbItem from 'antd/lib/breadcrumb/BreadcrumbItem';
import { HomeOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';

export interface IBreadcrumbsProps {}

function truncate(str: string | React.ReactNode, max: number = 45) {
  return str;
  // if (typeof str !== 'string') return str;
  // return str.length > max ? str.substr(0, max - 1) + '…' : str;
}
/**
 * Componente che visualizza l'elenco dei breadcrumb registrati.
 */
export function Breadcrumbs(props: IBreadcrumbsProps) {
  const items = useBreadcrumbs();
  const { labels } = useThemeConfig();

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <HomeOutlined />
        </BreadcrumbItem>
        {items.map(item => (
          <Breadcrumb.Item key={item.path || item.key}>
            {item.path ? (
              <Link
                title={typeof item.title == 'string' ? item.title : ''}
                to={{ pathname: item.path, state: item.state }}
              >
                {truncate(item.title)}
              </Link>
            ) : (
              truncate(item.title)
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
      <Helmet>
        <title>{`${items.map(i => i.title).join(' - ')}`}</title>
      </Helmet>
    </>
  );
}
